const ScalableSvg = ({ icon }) => {
    return <div className={'relative'}>{icon}</div>
}

export default ScalableSvg
